import request from '@/services/interceptor.js'

// Auth
export const login_user = (par) => {
    return request({
        url: '/auth/login',
        method: 'post',
        data: par,
        loadingBar: true
    })
}
export const logout_user = (par) => {
    return request({
        url: '/auth/logout',
        method: 'post',
        data: par,
        loadingBar: true
    })
}
export const refresh_token = (par) => {
    return request({
        url: '/auth/refreshtoken',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const verifica_reset_token = (token) => {
    return request({
        url: '/auth/reset-password/verifica',
        method: 'get',
        params: { token },
        loadingBar: false
    })
}

export const reimposta_password = (data) => {
    return request({
        url: '/auth/reset-password',
        method: 'put',
        data,
        loadingBar: true
    })
}

export const verifica_attivazione_token = (token) => {
    return request({
        url: '/auth/attivazione/verifica',
        method: 'get',
        params: { token },
        loadingBar: false
    })
}

export const attiva_account = (data) => {
    return request({
        url: '/auth/attivazione',
        method: 'post',
        data,
        loadingBar: true
    })
}